import { render, staticRenderFns } from "./SelfEvalCard.vue?vue&type=template&id=61367e22&scoped=true&"
import script from "./SelfEvalCard.vue?vue&type=script&lang=js&"
export * from "./SelfEvalCard.vue?vue&type=script&lang=js&"
import style0 from "./SelfEvalCard.vue?vue&type=style&index=0&id=61367e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61367e22",
  null
  
)

export default component.exports